var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001Buero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.667,
    height: 451.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 385.083,
    width: 385.083,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 673.124,
    cy: 236.636,
    id: "svg_5",
    rx: 213.741,
    ry: 213.823
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 110.613,
    y: 76.131,
    width: 29.159,
    height: 337.191,
    id: "svg_1",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 110.613,
    y: 76.131,
    width: 251.498,
    height: 21.388,
    id: "svg_2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 335.796,
    y: 69.958,
    width: 29.159,
    height: 311.906,
    id: "svg_3",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 144.627,
    y: 102.281,
    width: 194.387,
    height: 302.984,
    id: "svg_4",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.184607,376.570118c-1.143221,0 -2.280246,0.096958 -3.397133,0.290875c-4.560492,-8.03466 -13.238439,-13.218898 -23.040244,-13.218898c-9.801805,0 -18.479752,5.184238 -23.040244,13.218898c-1.116887,-0.193917 -2.253912,-0.290875 -3.397133,-0.290875c-10.931859,0 -19.828226,8.70049 -19.828226,19.391656c0,2.27549 0.475568,4.427509 1.222999,6.463633l-27.66115,0l0,-38.783311l33.047302,0c3.648084,0 6.609151,-2.895871 6.609151,-6.463633l0,-258.555156c0,-3.567762 -2.961067,-6.463633 -6.609151,-6.463633l-198.282263,0c-3.648084,0 -6.609151,2.895871 -6.609151,6.463633l0,310.26649c0,3.567762 2.961067,6.463633 6.609151,6.463633l264.376093,0c10.931859,0 19.828226,-8.70049 19.828226,-19.391656s-8.896367,-19.391656 -19.828226,-19.391656l-0.000001,0zm-99.141132,-271.483179l26.437377,0l0,38.783311l-26.437377,0l0,-38.783311zm0,51.711334l26.437377,0l0,38.783311l-26.437377,0l0,-38.783311zm0,51.710577l26.437377,0l0,38.783311l-26.437377,0l0,-38.783311zm0,51.711334l26.437377,0l0,38.783311l-26.437377,0l0,-38.783311zm0,51.711334l26.437377,0l0,38.783311l-26.437377,0l0,-38.783311zm-132.188434,90.493888l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.710577l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.710577l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm39.656453,258.555156l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.710577l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.710577l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm39.656453,258.555156l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.710577l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.710577l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm39.656453,258.555156l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.710577l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.710577l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm0,-51.711334l-26.437377,0l0,-38.783311l26.437377,0l0,38.783311zm112.360207,258.555156l-52.875528,0c-3.641888,0 -6.609151,-2.901931 -6.609151,-6.463633s2.967263,-6.463633 6.609151,-6.463633c1.268697,0 2.471557,0.355261 3.582248,1.053664c1.810875,1.137745 4.071757,1.344539 6.067747,0.555995c1.99599,-0.788543 3.46994,-2.482283 3.952478,-4.531285c1.394947,-5.8887 6.675761,-10.006397 12.835678,-10.006397c6.159917,0 11.440732,4.117697 12.835678,10.006397c0.482538,2.049001 1.956488,3.742741 3.952478,4.531285c1.99599,0.788543 4.256098,0.58175 6.067747,-0.555995c4.296374,-2.714832 10.198369,0.607504 10.191399,5.409969c-0.000775,3.561702 -2.968038,6.463633 -6.609925,6.463633z",
    id: "svg_6",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 161.641,
    y: 50.585,
    width: 147.011,
    height: 27.923,
    id: "svg_7",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 217.53,
    y: 36.92,
    width: 38.271,
    height: 17.823,
    id: "svg_8",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 37.107,
    y: 290.604,
    width: 43.739,
    height: 75.452,
    id: "svg_9",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 44.397,
    y: 270.404,
    width: 27.944,
    height: 27.329,
    id: "svg_10",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.425225,72.76726l0,-19.391656l46.265603,0c3.648084,0 6.609151,-2.895871 6.609151,-6.463633l0,-6.463633l26.437377,0l0,6.463633c0,3.567762 2.961067,6.463633 6.609151,6.463633l46.267152,0l0,12.928023l-112.360207,0c-3.648084,0 -6.609151,2.895871 -6.609151,6.463633s2.961067,6.463633 6.609151,6.463633l165.234961,0l0,268.115394c0,3.567762 2.961067,6.463633 6.609151,6.463633s6.609151,-2.895871 6.609151,-6.463633l0,-274.579026c0,-3.567762 -2.961067,-6.463633 -6.609151,-6.463633l-46.265603,0l0,-19.391656c0,-3.567762 -2.961067,-6.463633 -6.609151,-6.463633l-46.265603,0l0,-6.46439c0,-3.567762 -2.961067,-6.463633 -6.609151,-6.463633l-39.656453,0c-3.648084,0 -6.609151,2.895871 -6.609151,6.463633l0,6.463633l-46.266378,0c-3.648084,0 -6.609151,2.895871 -6.609151,6.463633l0,19.391656l-46.265603,0c-3.648084,0 -6.609151,2.895871 -6.609151,6.463633l0,329.658146l-39.657227,0l0,-26.508242c15.062481,-3.005707 26.437377,-16.056442 26.437377,-31.666725c0,-0.840053 -0.376426,-84.030255 -33.047302,-84.030255c-32.670101,0.000757 -33.046527,83.19096 -33.046527,84.031013c0,15.610283 11.374896,28.661019 26.437377,31.666725l0,26.508242l-19.828226,0c-3.648084,0 -6.609151,2.895871 -6.609151,6.463633s2.961067,6.46439 6.609151,6.46439l79.312905,0c3.648084,0 6.609151,-2.895871 6.609151,-6.463633l0,-329.658146l46.266378,0c3.648084,0 6.609151,-2.895871 6.609151,-6.46439l-0.000001,-0.000002zm-132.187659,271.483179c0,-32.203026 8.843699,-71.10299 19.828226,-71.10299c10.984528,0 19.828226,38.899964 19.828226,71.10299c0,10.691165 -8.896367,19.391656 -19.828226,19.391656s-19.828226,-8.70049 -19.828226,-19.391656z",
    id: "svg_11",
    fill: "#193351",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001Buero);
export default __webpack_public_path__ + "static/media/001 Buero.d891fc7160e967691b924c8b38fc8660.svg";
export { ForwardRef as ReactComponent };